export const orderConstants = {
    GETDETAIL_REQUEST: 'ORDERS_GETDETAIL_REQUEST',
    GETDETAIL_SUCCESS: 'ORDERS_GETDETAIL_SUCCESS',
    GETDETAIL_FAILURE: 'ORDERS_GETDETAIL_FAILURE',

    GETNEXT_REQUEST: 'ORDERS_GETNEXT_REQUEST',
    GETNEXT_SUCCESS: 'ORDERS_GETNEXT_SUCCESS',
    GETNEXT_FAILURE: 'ORDERS_GETNEXT_FAILURE',

    GETCURRENT_REQUEST: 'ORDERS_GETCURRENT_REQUEST',
    GETCURRENT_SUCCESS: 'ORDERS_GETCURRENT_SUCCESS',
    GETCURRENT_FAILURE: 'ORDERS_GETCURRENT_FAILURE',

    GETALLCURRENT_REQUEST: 'ORDERS_GETALLCURRENT_REQUEST',
    GETALLCURRENT_SUCCESS: 'ORDERS_GETALLCURRENT_SUCCESS',
    GETALLCURRENT_FAILURE: 'ORDERS_GETALLCURRENT_FAILURE',

    GETALLNEXT_REQUEST: 'ORDERS_GETALLNEXT_REQUEST',
    GETALLNEXT_SUCCESS: 'ORDERS_GETALLNEXT_SUCCESS',
    GETALLNEXT_FAILURE: 'ORDERS_GETALLNEXT_FAILURE',

    GETHISTORY_REQUEST: 'ORDERS_GETHISTORY_REQUEST',
    GETHISTORY_SUCCESS: 'ORDERS_GETHISTORY_SUCCESS',
    GETHISTORY_FAILURE: 'ORDERS_GETHISTORY_FAILURE',

    UPDATE_REQUEST: 'ORDERS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'ORDERS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'ORDERS_UPDATE_FAILURE',

    UPDATEAVAILABILITY_REQUEST: 'ORDERS_UPDATEAVAILABILITY_REQUEST',
    UPDATEAVAILABILITY_SUCCESS: 'ORDERS_UPDATEAVAILABILITY_SUCCESS',
    UPDATEAVAILABILITY_FAILURE: 'ORDERS_UPDATEAVAILABILITY_FAILURE',

    DELETE_REQUEST: 'ORDERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'ORDERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'ORDERS_DELETE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/order.constants.js